import React from 'react'
import { MetricCard } from './MetricCard'
import { SkillPill } from './SkillPill'
import { useGameplayContext } from '../../contexts/gameplayContext'
import { getOverallSkillLevel, getSurferRating, formatCurrency } from '../../utils'
import SKILL_TREE from '../../constants/skillTree'

interface SurfLevelCardProps {
  className?: string
  skillPoints?: number
}

export const SurfLevelCard: React.FC<SurfLevelCardProps> = ({ className, skillPoints }) => {
  const { gameData } = useGameplayContext()
  const lastAchievedLevel = getOverallSkillLevel(SKILL_TREE, gameData.skills)
  const surferRating = getSurferRating(gameData)
  const skillPointsValue = skillPoints !== undefined ? skillPoints : gameData.currencies.skill.amount

  return (
    <MetricCard
      emoji="🏄‍♂️"
      label="Surf Level"
      value={
        <div className="relative w-full">
          <div className="flex items-center">
            <div>{lastAchievedLevel ? `${surferRating} ⭐ - ${lastAchievedLevel.name}` : 'Beginner'}</div>
            <div className="text-xs text-blue-600 ml-2">({formatCurrency(skillPointsValue)} points)</div>
          </div>
          <div className="absolute -top-9 right-0">
            <SkillPill skill="All Skills" value={gameData.currencies.skill.totalMultiplier as number} />
          </div>
        </div>
      }
      className={className}
    />
  )
}
